import React, { useContext, useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
// actions
import { resetLoginFlag } from "../../store/actions";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { login } from '../../Services/DataServices';

const Login = (props) => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => ({
        user: state.Account.user,
    }));
    const navigate = useNavigate(); // Use useNavigate hook
    const [showPassword, setShowPassword] = useState(false);
    const [loginError, setLoginError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem("token");
        const user = JSON.parse(localStorage.getItem("user")) || {};
        if (token) {
            if (user.role === 'viewuser') {
                navigate("/fdf-master");
            } else {
                navigate("/data-curation");
            }
        }
    }, [navigate]);
    
    const checkLogin = async (data) => {
        const result = await login(data);
        if (result?.result?.response === true) {
            localStorage.setItem('user', JSON.stringify(result.result.result));
            localStorage.setItem('token', result.result.token);
            localStorage.setItem("isLoggedIn", "true");
            if (result.result.result.role === 'viewuser') {
                navigate("/fdf-master");
            } else {
                navigate("/data-curation");
            }
            toast.success('Login successful!');
        } else {
            setLoginError("Invalid email or password. Please try again.");
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required('Enter a valid email.'),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values) => {
            const response = await checkLogin(values);
            if (response.success) {
                navigate("/data-curation"); // Replace history.push with navigate
            } else {
                setLoginError("Invalid email or password. Please try again.");
            }
        }
    });

    const { error } = useSelector(state => ({
        error: state.Login.error,
    }));

    useEffect(() => {
        setTimeout(() => {
            dispatch(resetLoginFlag());
        }, 3000);
    }, [dispatch, error]);

    document.title = "Data Curation";
    return (
        <React.Fragment>
            <div className="auth-one-bg-position auth-one-bg">
                <div className="auth-page-content d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody style={{padding:30}}>
                                        <div className="text-center mt-2">
                                            <h3 className="text-primary">DATA CURATION PLATFORM</h3>
                                        </div>
                                        {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                action="#">
                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">Email</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation?.values?.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={showPassword ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <button
                                                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                                            type="button"
                                                            id="password-addon"
                                                            onClick={togglePasswordVisibility}
                                                        >
                                                            {showPassword ? (
                                                                <i className="ri-eye-off-fill align-middle"></i>
                                                            ) : (
                                                                <i className="ri-eye-fill align-middle"></i>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                                {loginError && (
                                                    <Alert color="danger" style={{ padding: '0.3rem' }}>
                                                        {loginError}
                                                    </Alert>
                                                )}

                                                <div className="mt-1">
                                                    <Button className="btn w-100"  style={{backgroundColor:"#4b38b3",borderColor:"#4b38b3"}} type="submit">Sign In</Button>
                                                </div>

                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Login;